// Importing Foundation first
// ### Core
import $ from 'jquery';
import 'what-input';
import 'parent_js/global/foundation';
$(document).foundation();
import 'parent_js/utils/utils';
// Import all your components here
// But don't code inside this file.

// Components
import 'parent_js/components/facetwp';
import 'parent_js/components/fixedHeader';
import 'parent_js/components/gravityForm';
import 'parent_js/components/lazyLoad';
import 'parent_js/components/loadPosts';
import 'parent_js/components/masonry';
import 'parent_js/components/mobileMenu';
import 'parent_js/components/photoswipe';
import 'parent_js/components/searchbar';
import 'parent_js/components/socialSharerToggle';
import 'parent_js/components/swiper';
import 'parent_js/components/smoothScroll';
import 'parent_js/components/toggler';
import 'parent_js/components/list';
import 'parent_js/components/filters';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}

// Signed by Choosit!
// console.log('GERANTOSUD');
console.log(`%c Made with ❤️ by Spiriit! `, `background-color: #3960ff; color: white;`);
